module.exports = __webpack_public_path__ + "static/img/2.e91b549c.png";